// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".creative-management-mf .merge-view-error-message[data-v-0b51442e]{color:red;margin:0 0 15px 0;display:-webkit-box;display:-ms-flexbox;display:flex}.creative-management-mf .merge-view-red-border[data-v-0b51442e]{border:1px solid red;padding-bottom:1px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
